import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type WechatFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const WechatFilled = forwardRef<SVGSVGElement, WechatFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-2.065349 -0.732773) scale(1.095143)">
        <path d="M9.98073 14.0828C9.88599 14.1307 9.7791 14.1583 9.66556 14.1583C9.40313 14.1583 9.1749 14.0137 9.05512 13.8002L9.0092 13.6995L7.0975 9.50485C7.07687 9.45904 7.06397 9.40765 7.06397 9.35755C7.06397 9.16414 7.22068 9.00729 7.41409 9.00729C7.49263 9.00729 7.56506 9.03326 7.62366 9.07682L9.87935 10.6828C10.0443 10.7908 10.2411 10.854 10.4527 10.854C10.5793 10.854 10.6996 10.8305 10.812 10.7895L21.4209 6.06782C19.5194 3.82675 16.3875 2.36197 12.8433 2.36197C7.04373 2.36197 2.34248 6.27974 2.34248 11.1126C2.34248 13.7496 3.75702 16.123 5.97082 17.727C6.14854 17.8537 6.26466 18.062 6.26466 18.2971C6.26466 18.3748 6.24797 18.4462 6.22787 18.5202C6.05104 19.1799 5.76789 20.2359 5.7547 20.2854C5.73266 20.3681 5.69807 20.4546 5.69807 20.5412C5.69807 20.7345 5.85493 20.8912 6.04833 20.8912C6.12453 20.8912 6.18638 20.8631 6.25059 20.8261L8.54947 19.499C8.72237 19.399 8.90547 19.3373 9.10707 19.3373C9.21435 19.3373 9.31808 19.3538 9.41584 19.3837C10.4882 19.6921 11.6453 19.8636 12.8433 19.8636C18.6427 19.8636 23.3443 15.9457 23.3443 11.1127C23.3443 9.64897 22.9107 8.27029 22.1482 7.05777L10.0573 14.0385L9.98073 14.0828Z" />
      </g>
    </svg>
  ),
);

WechatFilled.displayName = 'WechatFilled';

export default WechatFilled;
